import { Outlet } from "react-router-dom";
import TabNav, { TabItem } from "../../../../Components/Extra/Tab/TabNav";
import BreadCrumbV2, {
    Ariane,
} from "../../../../Layouts/Account/BreadCrumb/BreadCrumbV2";

const navigation: TabItem[] = [
    {
        path: "clisha",
        name: "CLISHA",
    },
    {
        path: "fiat",
        name: "Fiat",
    },
    {
        path: "swap",
        name: "Swap",
    },
    {
        path: "clisha-stake",
        name: "CLISHA STAKE",
    },
];

const AssetConfig = () => {
    const Arianes: Ariane[] = [
        {
            path: "#",
            name: "Admin",
        },
        {
            path: "/admin/setting",
            name: "Setting",
        },
        {
            path: "",
            name: "Asset",
        },
    ];

    return (
        <>
            <BreadCrumbV2 arianes={Arianes} />
            <h2 className="intro-y mt-10 bg-white p-2 rounded text-lg font-medium">
                Asset Config
            </h2>
            <div className="mt-5 pt-5">
                <TabNav items={navigation} />
                <div className="intro-y col-span-12 box">
                    <div className="-mx-5 flex flex-col border-b border-slate-200/60 pb-5 lg:flex-row relative p-3">
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AssetConfig;
